import { Box, Button, Checkbox, Flex, HStack, Link } from '@chakra-ui/react';
import { Icon } from '@common/components/Icon';
import config from '@common/config';
import { AgreementCode } from '@services/appsync/types';
import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { UI } from 'src/apps/invest/common/shells/UI';
import { useInboxModel } from '../../../../../common/models/InboxModel';
import { useInvestorAccountModel } from '../../../../../common/models/InvestorAccountModel';
import { TextBlock } from '../../../common/components/TextBlock';
import { ROUTES } from '../../../config';
import { useInboxViewModel } from '../../models/InboxViewModel';

const iconSize = {
  desktop: 80,
  mobile: 60,
};

export const DwollaTerms: React.FC = () => {
  const [concreitAgreementChecked, setConcreitAgreementChecked] = useState(false);
  const [dwollaAgreementChecked, setDwollaAgreementChecked] = useState(false);
  const [processing, setProcessing] = useState(false);

  const navigate = useNavigate();

  const model = useInboxViewModel();
  const investorModel = useInvestorAccountModel();
  const inboxModel = useInboxModel();
  return (
    <UI>
      <Flex flex={1} alignItems="center" flexDirection="column" justifyContent={'center'}>
        <Flex flexDirection={'column'} alignItems={'center'} maxWidth={520}>
          <Box
            w={[iconSize.mobile + 'px', iconSize.desktop + 'px']}
            h={[iconSize.mobile + 'px', iconSize.desktop + 'px']}
            position="relative">
            <Box
              bgColor={'blue.50'}
              w={[iconSize.mobile + 'px', iconSize.desktop + 'px']}
              h={[iconSize.mobile + 'px', iconSize.desktop + 'px']}
              position="absolute"
              borderRadius={[iconSize.mobile, iconSize.desktop]}></Box>
            <Box
              bgColor={['transparent', 'blue.100']}
              opacity={0.5}
              w={[iconSize.mobile - 20 + 'px', iconSize.desktop - 20 + 'px']}
              h={[iconSize.mobile - 20 + 'px', iconSize.desktop - 20 + 'px']}
              position="absolute"
              borderRadius={60}
              top={[
                (iconSize.mobile - (iconSize.mobile - 20)) / 2 + 'px',
                (iconSize.desktop - (iconSize.desktop - 20)) / 2 + 'px',
              ]}
              left={[
                (iconSize.mobile - (iconSize.mobile - 20)) / 2 + 'px',
                (iconSize.desktop - (iconSize.desktop - 20)) / 2 + 'px',
              ]}></Box>
            <Icon
              icon={'file-contract'}
              boxSize={[iconSize.mobile * 0.3 + 'px', iconSize.desktop * 0.3 + 'px']}
              color={'blue.300'}
              top={[
                (iconSize.mobile - iconSize.mobile * 0.3) / 2 + 'px',
                (iconSize.desktop - iconSize.desktop * 0.3) / 2 + 'px',
              ]}
              left={[
                (iconSize.mobile - iconSize.mobile * 0.3) / 2 + 'px',
                (iconSize.desktop - iconSize.desktop * 0.3) / 2 + 'px',
              ]}
              position="absolute"
            />
          </Box>
          <TextBlock textAlign="center" mt={'20px'} fontSize={'24px'} weight="bold">
            Upgrading Payments
          </TextBlock>

          <TextBlock mt={'24px'} textAlign="center">
            {
              'We are upgrading our banking and ACH rails. To ensure that your service continues seamlessly, please review & accept the terms'
            }
          </TextBlock>
        </Flex>
        <Flex mt={'40px'} flexDirection="column" alignItems="center">
          <Box>
            <HStack cursor="pointer" alignItems={'flex-start'}>
              <Checkbox
                isChecked={concreitAgreementChecked}
                onChange={(e) => {
                  e.stopPropagation();
                  setConcreitAgreementChecked(!concreitAgreementChecked);
                }}
                mt={'4px'}></Checkbox>
              <TextBlock
                onClick={(e) => {
                  e.stopPropagation();

                  setConcreitAgreementChecked(!concreitAgreementChecked);
                }}>
                By checking this box, you agree to Concreit's{' '}
                <Link
                  href={config.TERMS}
                  target={'_blank'}
                  onClick={(e) => {
                    e.stopPropagation();
                  }}>
                  Terms of Service
                </Link>
                {' and '}
                <Link
                  href={config.PRIVACY_POLICY}
                  target={'_blank'}
                  onClick={(e) => {
                    e.stopPropagation();
                  }}>
                  Privacy Policy
                </Link>
              </TextBlock>
            </HStack>
            <HStack cursor={'pointer'} mt={'24px'} alignItems={'flex-start'}>
              <Checkbox
                isChecked={dwollaAgreementChecked}
                onChange={(e) => {
                  e.stopPropagation();
                  setDwollaAgreementChecked(!dwollaAgreementChecked);
                }}
                mt={'4px'}></Checkbox>
              <TextBlock
                onClick={(e) => {
                  e.stopPropagation();

                  setDwollaAgreementChecked(!dwollaAgreementChecked);
                }}>
                By checking this box, you agree to our partner Dwolla's{' '}
                <Link
                  href={config.DWOLLA_TERMS_OF_SERVICE}
                  target={'_blank'}
                  onClick={(e) => {
                    e.stopPropagation();
                  }}>
                  Terms of Service
                </Link>
                {' and '}
                <Link
                  href={config.DWOLLA_PRIVACY_POLICY}
                  target={'_blank'}
                  onClick={(e) => {
                    e.stopPropagation();
                  }}>
                  Privacy Policy
                </Link>
              </TextBlock>
            </HStack>
          </Box>
          <Button
            isLoading={processing}
            onClick={async () => {
              setProcessing(true);
              const res = await model.acceptAgreements([AgreementCode.DWOLLA_TOU_PRIVACY, AgreementCode.TOU_PRIVACY]);
              if (res.success) {
                const investorResponse = await investorModel.fetchInvestorAccount();
                inboxModel.checkForAlerts(investorResponse.investorAccount);
                navigate(ROUTES.inbox);
              } else {
                alert('Unable to sign agreement. Please try again.');
                setProcessing(false);
              }
            }}
            isDisabled={!dwollaAgreementChecked || !concreitAgreementChecked}
            mt={'36px'}>
            Accept Terms
          </Button>
        </Flex>
      </Flex>
    </UI>
  );
};
